/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { ReverseZoneChangeExternal } from "../../models/reverse-zone-change-external";
import { ReverseZoneChangePrimary } from "../../models/reverse-zone-change-primary";
import { ReverseZoneExternalRead } from "../../models/reverse-zone-external-read";
import { ReverseZonePrimaryRead } from "../../models/reverse-zone-primary-read";
import { Status } from "../../models/status";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ChangeReverseZone$Params {
  organisation_id: string;
  reverse_zone_id: number;
  check?: boolean;
  body: ReverseZoneChangePrimary | ReverseZoneChangeExternal;
}

export function changeReverseZone(
  http: HttpClient,
  rootUrl: string,
  params: ChangeReverseZone$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<(ReverseZonePrimaryRead | ReverseZoneExternalRead) | Status>> {
  const rb = new RequestBuilder(rootUrl, changeReverseZone.PATH, "put");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("reverse_zone_id", params.reverse_zone_id, {});
    rb.query("check", params.check, {});
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(ReverseZonePrimaryRead | ReverseZoneExternalRead) | Status>;
    }),
  );
}

changeReverseZone.PATH = "/surfdomeinen/organisations/{organisation_id}/reverse/{reverse_zone_id}";
